module.exports = __webpack_public_path__ + "img/9788960516465.6373990f.jpg";